// App.js

import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { UserProvider } from "./context/UserContext";
import { AppConfigProvider } from "./context/AppConfigContext";
import PageNotFound from "./components/Error/PageNotFound";

import { authRoutes } from "./routes/AuthRoutes";
import { userRoutes } from "./routes/UserRoutes";
import { companyRoutes } from "./routes/CompanyRoutes";
import { accountRoutes } from "./routes/AccountRoutes";
import { frontendRoutes } from "./routes/FrontendRoutes";
import { userStatRoutes } from "./routes/UserStatRoutes";

import { FlashMessageProvider } from "./context/FlashContext";
import { dashboardRoutes } from "./routes/DashboardRoutes";
import { accountDetailsRoute } from "./routes/AccountDetailsRoute";
import { accountsRoute } from "./routes/AccountsRoute";
import { saleAccountsRoute } from "./routes/SalesAccountsRoute";
import { growthOpportunitiesRoute } from "./routes/GrowthOpportunitiesRoutes";
import { nudgesRoutes } from "./routes/NudgesRoutes";
import { onBoardingRoutes } from "./routes/OnBoardingRoutes";
import { userProfileRoutes } from "./routes/UserProfileRoutes";
import { verifyTokenRoutes } from "./routes/VerifyTokenRoutes";
import { chatRoute } from "./routes/ChatRoute";
import React, { useEffect } from "react";
import { Provider } from "react-redux";
import store from "./store/store";
import AgreementCheck from "./components/Frontend/Agreements/userJoinAgreement";
import { demoRequestsRoutes } from "./routes/DemoRequestsRoutes";
import { TaskStatusProvider } from "./context/TaskStatusContext";
import { BannerProvider } from "./context/BannerContext";
import { GroupTaskWebSocketProvider } from "./context/GroupTaskWebSocketContext";
import { meetingPrepsRoutes } from "./routes/MeetingPrepsRoutes";
import { benchmarksRoute } from "./routes/BenchmarksRoute";
import { watchboardRoutes } from "./routes/WatchboardRoutes";
import { revenueTeardownRoutes } from "./routes/RevenueTeardownRoutes";
import { WeeklyReportRoutes } from "./routes/WeeklyReportRoutes";
import { compProfilesRoute } from "./routes/CompProfilesRoute";
import { competitorsRoute } from "./routes/CompetitorsRoute";
import { newsRoutes } from "./routes/NewsRoutes";
import { marketsRoutes } from "./routes/MarketsRoutes";
import ChatbotGate from "./ChatbotGate";
import ProtectedRoute from "./components/Auth/ProtectedRoute";
import { clientsWithIndustriesRoute } from "./routes/ClientsWithIndustriesRoute";
import { externalWebsiteRoutes } from "./routes/ExternalWebsiteRoutes";
import { competitorsSuggestionsRoute } from "./routes/CompetitorsSuggestionsRoute";
import { customersRoutes } from "./routes/CustomersRoutes";
import { deepResearchRoutes } from "./routes/DeepResearchRoutes";
import { newFeaturesRoutes } from "./routes/NewFeaturesRoutes";
import { useUser } from "./context/UserContext";

function App() {
  const { user } = useUser();
  useEffect(() => {
    const currentBuild = process.env.REACT_APP_BUILD_TIME;

    // skip in dev / undefined case
    if (!currentBuild) return;

    const savedBuild = localStorage.getItem("build_version");

    if (savedBuild && savedBuild !== currentBuild) {
      window.location.reload();
    }

    localStorage.setItem("build_version", currentBuild);
  }, []);

  useEffect(() => {
    if (user?.user_id && window.hj) {
      let usersName = user?.first_name + " " + user?.last_name;
      let companyName = user?.company_name_for_growth_iq || "-";
      window.hj("identify", user?.user_id, {
        email: user?.email,
        name: usersName,
        companyName: companyName,
      });
    }
  }, [user]);

  return (
    <AppConfigProvider>
      <BannerProvider>
        <Provider store={store}>
          {/* <UserProvider> */}
          <GroupTaskWebSocketProvider>
            <TaskStatusProvider>
              <FlashMessageProvider>
                <Router>
                  <Routes>
                    {verifyTokenRoutes}
                    {authRoutes}
                    {/* Protected Routes - Require authentication */}
                    <Route element={<ProtectedRoute />}>
                      {userRoutes}
                      {companyRoutes}
                      {accountRoutes}
                      {frontendRoutes}
                      {dashboardRoutes}
                      {accountDetailsRoute}
                      {watchboardRoutes}
                      {benchmarksRoute}
                      {competitorsRoute}
                      {competitorsSuggestionsRoute}
                      {compProfilesRoute}
                      {revenueTeardownRoutes}
                      {externalWebsiteRoutes}
                      {WeeklyReportRoutes}
                      {newsRoutes}
                      {marketsRoutes}
                      {accountsRoute}
                      {saleAccountsRoute}
                      {onBoardingRoutes}
                      {userProfileRoutes}
                      {growthOpportunitiesRoute}
                      {nudgesRoutes}
                      {userStatRoutes}
                      {chatRoute}
                      {demoRequestsRoutes}
                      {clientsWithIndustriesRoute}
                      {customersRoutes}
                      {deepResearchRoutes}
                      {newFeaturesRoutes}
                    </Route>

                    <Route path="*" element={<PageNotFound />} />
                  </Routes>
                </Router>
              </FlashMessageProvider>
            </TaskStatusProvider>
          </GroupTaskWebSocketProvider>
          {/* </UserProvider> */}
        </Provider>
      </BannerProvider>
    </AppConfigProvider>
  );
}

export default App;
